export const FlipCardSide = Object.freeze({
	front: 'front',
	back: 'back'
});

export const FlipCardSideName = Object.freeze({
	front: 'Front Side',
	back: 'Back Side'
});